import { CartItemRequirementType, Product } from "../../src/interfaces";
import { useContext, useMemo } from "react";
// import useApi from "./useApi";
import CartContext, { ICartContext } from "src/context/CartContext";
export type UseOrderResult = {
  requiresAdditional: boolean;
  requiresMedical: boolean;
  getItemRequirements: (item: Product) => CartItemRequirementType[];
} & ICartContext;

const getItemRequirements = (item: Product): CartItemRequirementType[] => {
  let requirements = [];
  if (item.IsExtended)
    requirements.push(CartItemRequirementType.Additional);
  if (item.IsMedical) requirements.push(CartItemRequirementType.Medical);

  return requirements;
};

const useOrder = (): UseOrderResult => {
  const { items, ...cart } = useContext(CartContext);
  // const { post } = useApi();

  const requiresAdditional = useMemo(
    () =>
      items.reduce((res, current) => {
        let req = getItemRequirements(current);
        return (res = res || req.includes(CartItemRequirementType.Additional));
      }, false),
    [items],
  );
  const requiresMedical = useMemo(
    () =>
      items.reduce((res, current) => {
        let req = getItemRequirements(current);
        return (res = res || req.includes(CartItemRequirementType.Medical));
      }, false),
    [items],
  );

  return {
    ...cart,
    requiresMedical,
    requiresAdditional,
    items,
    getItemRequirements,
  };
};

export default useOrder;
